import { Button } from '@mui/material'
import React, { useState, useContext, useEffect } from 'react'

import PrimaryButton from '@/product/components/atoms/PrimaryButton'

import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import { useHistory } from 'react-router-dom'
// import Popup from '@/product/components/organisms/Popup'
// import Timer from '../../../common/timer'
import { useFormik } from 'formik'
import moment from 'moment'
import * as Yup from 'yup'

import BuyerContext from '@/product/context/userBuyer/buyerContext'
import AuthContext from '@/product/context/auth/authContext'
import CustomCommonContext from '@/custom/context/common/commonContext'
import SettingContext from '@/product/context/setting/settingContext'
import UserContext from '@/product/context/user/userContext'

import CustomDialog from '@/product/components/organisms/Dialog'
import ScheduledPickupContext from '@/product/context/scheduledPickup/scheduledPickupContext'
import {
    handleRedirectInternal,
    currencyFormat,
} from '@/product/common/components'
import { mapData } from '@/product/common/components'

const Bidding = (props) => {
    let data = props.data
    const t = (text) => {
        text = text.charAt(0).toUpperCase() + text.slice(1)
        return text.replace(/_/g, ' ')
    }
    const settingcontext = useContext(SettingContext)
    const buyerContext = useContext(BuyerContext)
    const authContext = useContext(AuthContext)
    const userContext = useContext(UserContext)

    const { all_bidding_users } = userContext

    let { bidConfirm } = buyerContext
    const { isAuthenticated } = authContext
    const [product, setProduct] = useState()
    const [biddingUsers, setBiddingUsers] = useState([])
    const history = useHistory()
    const [locationDropdown, setLocationDropdown] = useState([])
    const [parkingLotDropdown, setParkingLotDropdown] = useState([])
    const [toggleDialog, setToggleDialog] = useState(false)
    const [toggleDialogDeposit, setToggleDialogDeposit] = useState(false)
    const commonContext = useContext(CustomCommonContext)
    const { allLocations } = commonContext
    const scheduledPickupContext = useContext(ScheduledPickupContext)
    const { responseStatus, clearResponse } = scheduledPickupContext
    const {
        searchTableFetch,
        searchTableAction,
        search_fetch_data,
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseCommuncation,
    } = settingcontext
    const changeDialogStatus = () => {
        setToggleDialog(!toggleDialog)
    }

    const changeDialogStatusDeposit = () => {
        setToggleDialogDeposit(!toggleDialogDeposit)
    }

    useEffect(() => {
        if (
            search_fetch_data &&
            search_fetch_data.from === 'locationDropdown'
        ) {
            let data = []
            if (search_fetch_data.records.length) {
                data = search_fetch_data.records.map((country) => {
                    let busCategoryChanged = {}
                    busCategoryChanged.show = country.name
                    busCategoryChanged.value = country.id
                    return busCategoryChanged
                })
            }
            setLocationDropdown(data)
        }
    }, [search_fetch_data])

    useEffect(() => {
        let obj = {
            filters: {
                status: {
                    value: 1,
                    type: 'in',
                    field: 'l.active',
                },
            },
            page: 1,
            limit: 20,
            primaryTable: 'locations',
        }
        searchTableFetch(obj, 'locationDropdown')
    }, [])

    const validationArray = Yup.object({
        // user_id: Yup.string().required(t('enter_user_id')),
        name: Yup.string().required('Required!'),
        email: Yup.string()
            .email('Invalid email format')
            .max(250, 'Maximum 250 characters')
            .required('Required'),
        phone: Yup.string()
            .trim()
            .matches(/^[0-9- +()]*$/g, 'Only Numbers Are Allowed')
            .required('Required'),
        location_id: Yup.string().required(t('Required!')),
        invoice_id: Yup.string().required(t('Required!')),
        booking_start_date: Yup.date('Please enter valid date!')
            .nullable()
            .transform((__, value) =>
                value && typeof value === 'string'
                    ? new Date(
                          moment(new Date(value.replace(/-/g, '/'))).subtract(
                              1,
                              'minutes'
                          )
                      )
                    : new Date(moment(value).subtract(1, 'minutes'))
            )
            .required('Required!'),
        booking_end_date: Yup.date('Please enter valid date!')
            .min(
                Yup.ref('booking_start_date'),
                'Should be greater than start Time'
            )
            .nullable()
            .transform((__, value) =>
                value && typeof value === 'string'
                    ? new Date(
                          moment(new Date(value.replace(/-/g, '/'))).subtract(
                              1,
                              'minutes'
                          )
                      )
                    : new Date(moment(value).subtract(1, 'minutes'))
            )
            .required('Required!'),
    })

    const formik = useFormik({
        initialValues: {
            name: '',
            email: '',
            phone: '',
            invoice_id: '',
            booking_end_date: '',
            booking_start_date: '',
            location_id: '',
            parking_lot_no: '',
            notes: '',
        },
        validationSchema: validationArray,
        onSubmit: (values) => {
            values.schedule_status =
                data.type === 'one'
                    ? 'booking'
                    : data.type === 'two'
                    ? 'waiting'
                    : data.type === 'three'
                    ? 'serving'
                    : 'completed'
            values.booking_start_date = moment(
                values.booking_start_date,
                'MM-DD-YYYY h:mm:a'
            ).format()
            values.booking_end_date = moment(
                values.booking_end_date,
                'MM-DD-YYYY h:mm:a'
            ).format()
            props.submitFunction(values)
        },
    })

    useEffect(() => {
        if (formik.values.location_id !== '' && allLocations?.length) {
            let parkData = allLocations
                .filter(
                    (item) =>
                        item.active == 1 && item.id == formik.values.location_id
                )
                ?.map((data) => {
                    const allpark =
                        data.parking_slot &&
                        data.parking_slot
                            .split(',')
                            .map((item) => ({ value: item }))

                    if (allpark && allpark.length) {
                        return allpark?.map((item) => {
                            return {
                                show: item.value,
                                value: item.value,
                            }
                        })
                    }
                })

            setParkingLotDropdown(...parkData)
        }
    }, [formik.values.location_id, allLocations])

    useEffect(() => {
        if (
            responseStatus &&
            (responseStatus.from == 'popupSubmit' ||
                responseStatus.from == 'scheduledPickupAction')
        ) {
            if (responseStatus.status === 'success') {
                formik.resetForm()
            }
            clearResponse()
        }
    }, [responseStatus])

    useEffect(() => {
        formik.values.bidding_type = props.type
    }, [props.type])

    const spAddFields = [
        {
            label: 'Name',
            type: 'text',
            placeholder: 'Enter Nmae',
            class: 'col-sm-6 col-12',
            name: 'name',
            formik: formik,
        },
        {
            label: 'Email',
            type: 'text',
            placeholder: 'Enter Email',
            class: 'col-sm-6 col-12',
            name: 'email',
            formik: formik,
        },
        {
            label: 'Phone',
            type: 'text',
            placeholder: 'Enter Phone',
            class: 'col-sm-6 col-12',
            name: 'phone',
            formik: formik,
        },
        {
            label: 'Location',
            type: 'select',
            placeholder: 'Select Location',
            class: 'col-sm-6 col-12',
            options: locationDropdown,
            name: 'location_id',
            formik: formik,
        },
        {
            label: 'Parking Lot',
            type: 'select',
            placeholder: 'Select Parking Lot',
            class: 'col-sm-6 col-12',
            options: parkingLotDropdown,
            name: 'parking_lot_no',
            formik: formik,
            native: true,
        },
        {
            label: 'Invoice ID',
            type: 'text',
            placeholder: 'Enter Invoice ID',
            class: 'col-sm-6 col-12',

            name: 'invoice_id',
            formik: formik,
        },
        {
            label: 'Start Date',
            type: 'datetime',
            placeholder: 'Enter Start Date',
            class: 'col-sm-6 col-12',
            name: 'booking_start_date',
            formik: formik,
        },
        {
            label: 'End Date',
            type: 'datetime',
            placeholder: 'Enter End Date',
            class: 'col-sm-6 col-12',
            name: 'booking_end_date',
            formik: formik,
        },
        {
            label: 'Notes',
            type: 'text',
            placeholder: 'Enter Notes',
            class: 'col-sm-6 col-12',
            name: 'notes',
            formik: formik,
        },
    ]

    return (
        <>
            <CustomDialog
                open={data.popup}
                size="md"
                function={() => {
                    props.function(false, 'new', null)
                    formik.resetForm()
                }}
                modaltitle="Add Card Details"
                title={
                    data.type === 'one'
                        ? 'Add New Booking'
                        : data.type === 'two'
                        ? 'Add New waitlist'
                        : data.type === 'three'
                        ? 'Add New Serving'
                        : 'Add New Completed'
                }
                closeBtn={true}
            >
                <div className="cardDetails ss">
                    <form onSubmit={formik.handleSubmit} autoComplete="nofill">
                        <div className="row">{mapData(spAddFields)}</div>
                        <div className="row">
                            <div className="sfActionButton col-12 d-flex justify-content-end align-items-center flex-wrap">
                                <SecondaryButton
                                    label="Cancel"
                                    btnSize="large"
                                    onClick={() => {
                                        props.function(false, 'new', null)
                                        formik.resetForm()
                                    }}
                                    disabled={false}
                                />
                                <PrimaryButton
                                    id="cardDetails_submit"
                                    disabled={false}
                                    btnSize="large"
                                    type="submit"
                                    label={'Save'}
                                />
                            </div>
                        </div>
                    </form>
                </div>
            </CustomDialog>
        </>
    )
}

export default Bidding
